

function transformCategoryTemplateWhatsApp(category) {
    switch (category) {
        case 'UTILITY':
            return 'Utilitário/Serviço';
        case 'MARKETING':
            return 'Marketing';
        case 'AUTHENTICATION':
            return 'Autenticação';
    }
}

function transformStatusTemplateWhatsApp(status) {
    switch (status) {
        case 'APPROVED':
            return 'Aprovado';
        case 'PENDING':
            return 'Pendente';
        case 'REJECTED':
            return 'Rejeitado';
        default:
            return status;
    }
}

export { transformCategoryTemplateWhatsApp, transformStatusTemplateWhatsApp };